import Img from "@pagerland/common/src/components/Img";
import styled from "styled-components";

export const StyledImg = styled(Img)`
  object-fit: cover;
  filter: saturate(0.96) contrast(0.98);
`;
